import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { ICostCentre, ICostCentreResponse, ICostCentreFormInputs } from "../../utils/costCentre.types";

/**
 * Fetch all cost centres
 */
export const fetchCostCentres = createAsyncThunk(
    'costCentre/fetchAll',
    async (params: { activeOnly?: boolean; categoryId?: string; useForPayroll?: boolean; useForPayments?: boolean } = {}): Promise<ICostCentreResponse> => {
        const { activeOnly = true, categoryId, useForPayroll, useForPayments } = params;
        let url = `/api/v1/cost-centres?activeOnly=${activeOnly}`;
        if (categoryId) {
            url += `&categoryId=${categoryId}`;
        }
        if (useForPayroll !== undefined) {
            url += `&useForPayroll=${useForPayroll}`;
        }
        if (useForPayments !== undefined) {
            url += `&useForPayments=${useForPayments}`;
        }
        const response = await axios.get(url);
        return response.data;
    }
);

/**
 * Fetch cost centre by ID
 */
export const fetchCostCentreById = createAsyncThunk(
    'costCentre/fetchById',
    async (id: string): Promise<ICostCentreResponse> => {
        const response = await axios.get(`/api/v1/cost-centres/${id}`);
        return response.data;
    }
);

/**
 * Create cost centre
 */
export const createCostCentre = createAsyncThunk(
    'costCentre/create',
    async (data: ICostCentreFormInputs): Promise<ICostCentreResponse> => {
        const response = await axios.post(`/api/v1/cost-centres`, data);
        return response.data;
    }
);

/**
 * Update cost centre
 */
export const updateCostCentre = createAsyncThunk(
    'costCentre/update',
    async ({ id, data }: { id: string; data: Partial<ICostCentreFormInputs> }): Promise<ICostCentreResponse> => {
        const response = await axios.put(`/api/v1/cost-centres/${id}`, data);
        return response.data;
    }
);

/**
 * Delete cost centre
 */
export const deleteCostCentre = createAsyncThunk(
    'costCentre/delete',
    async (id: string): Promise<ICostCentreResponse> => {
        const response = await axios.delete(`/api/v1/cost-centres/${id}`);
        return response.data;
    }
);
